/**
 * The `SortableOnDragOverEvent` event.
 */
var SortableOnDragOverEvent = /** @class */ (function () {
    /**
     * @hidden
     */
    function SortableOnDragOverEvent(target, prevIndex, nextIndex, newState) {
        this.target = target;
        this.prevIndex = prevIndex;
        this.nextIndex = nextIndex;
        this.newState = newState;
    }
    return SortableOnDragOverEvent;
}());
export { SortableOnDragOverEvent };
//# sourceMappingURL=SortableOnDragOverEvent.js.map